import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "quality-container" }
const _hoisted_2 = { class: "container-main" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"quality-section-info\"><div class=\"info-label\"><i class=\"dd-icon icon-quality-control\"></i><span class=\"label-text\">品控</span></div><div class=\"info-value\"><span class=\"value-text\">质检合格</span><i class=\"dd-icon icon-qualified\"></i></div></div>", 1)
const _hoisted_4 = {
  key: 0,
  class: "quality-section-info"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "info-label" }, [
  /*#__PURE__*/_createVNode("i", { class: "dd-icon icon-taste-test" }),
  /*#__PURE__*/_createVNode("span", { class: "label-text" }, "口感测试")
], -1)
const _hoisted_6 = { class: "info-value taste" }
const _hoisted_7 = { class: "stars" }
const _hoisted_8 = { class: "value-text" }
const _hoisted_9 = {
  key: 1,
  class: "quality-section-info"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "info-label" }, [
  /*#__PURE__*/_createVNode("i", { class: "dd-icon icon-sugar" }),
  /*#__PURE__*/_createVNode("span", { class: "label-text" }, "糖度值%Brix")
], -1)
const _hoisted_11 = { class: "info-value" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.tasteDesc)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrTaste, (item) => {
                  return (_openBlock(), _createBlock("i", {
                    class: "dd-icon icon-star-red",
                    key: item
                  }))
                }), 128 /* KEYED_FRAGMENT */)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrNotaste, (item) => {
                  return (_openBlock(), _createBlock("i", {
                    class: "dd-icon icon-star-gray",
                    key: item
                  }))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.tasteDesc), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.brix)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.brix), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}